import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IPage } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
})
export class HelpComponent implements OnInit {

  page: IPage = {
    id: 'loading',
    title: 'Loading',
    content: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    this.service.setPage('help');

    // Fetch the page
    this.service.getHttpPage()
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Show the help
   */
  private handleSuccess(resp: HttpResponse<any>) {
    this.page = {
      id: resp.body.id,
      title: resp.body.title,
      content: resp.body.content
    };
    this.service.setPage('');
  }
}
